document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".tab-local").forEach(container => {

    const arrayRoleTabs = container.querySelectorAll('[role="tab"]');
    const arrayRoleTabPanels = container.querySelectorAll('[role="tabpanel"]');
    const jsTabList = container.querySelector(".js-tab-local__list");

    if (!arrayRoleTabs.length || !arrayRoleTabPanels.length) return;

    function activateTab(tab, setFocus = false) {
      arrayRoleTabs.forEach(t => {
        t.setAttribute("aria-selected", "false");
        t.setAttribute("tabindex", "-1");
      });

      tab.setAttribute("aria-selected", "true");
      tab.setAttribute("tabindex", "0");

      if (setFocus) {
        tab.focus();
      }

      const targetId = tab.getAttribute("aria-controls");

      arrayRoleTabPanels.forEach(panel => {
        panel.classList.toggle(
          "state-tab-local__panel--active",
          panel.id === targetId
        );
      });
    }

    function onKeydown(e, tab) {
      const tabs = Array.from(arrayRoleTabs);
      const index = tabs.indexOf(tab);
      let newIndex = null;

      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
          newIndex = (index + 1) % tabs.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          newIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          newIndex = 0;
          break;
        case "End":
          newIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      activateTab(tabs[newIndex], true);
    }

    function updateTabsShadows() {
      if (!jsTabList) return;

      const scrollLeft = jsTabList.scrollLeft;
      const maxScrollLeft = jsTabList.scrollWidth - jsTabList.clientWidth;

      container.classList.toggle(
        "tab-global--helper-scrollable-left",
        scrollLeft > 0
      );
      container.classList.toggle(
        "tab-global--helper-scrollable-right",
        Math.ceil(scrollLeft) < maxScrollLeft
      );
    }

    window.addEventListener("resize", updateTabsShadows);
    jsTabList?.addEventListener("scroll", updateTabsShadows);

    arrayRoleTabs.forEach(tab => {
      tab.addEventListener("click", () => activateTab(tab, true));
      tab.addEventListener("keydown", e => onKeydown(e, tab));
    });

    // Init without focus
    const initialTab =
      Array.from(arrayRoleTabs).find(t => t.getAttribute("aria-selected") === "true")
      || arrayRoleTabs[0];

    activateTab(initialTab);
    updateTabsShadows();
  });
});
